import React from 'react';
import { observer } from 'mobx-react';

import { useDataStore } from 'state/DataStore';

import SVGSelector from 'components/SVGSelector';


const UnitSelector = observer(({ level, ...props }) => {
    const dataStore = useDataStore();
    
    const { acf: { plan_image, plan_svg } } = level;
    
    const image = plan_image?.url;
    const svg = plan_svg?.url;

    const setupUnitElem = (elem) => {
        const unit = dataStore.getItem('units', 'slug', elem.id);
        const unitType = dataStore.getItem('unit_types', 'id', unit.acf.unit_type);
        const category = dataStore.getItem('unit_categories', 'id', unitType.unit_categories[0]);

        elem.dataset.status = unit.acf.status;
        elem.dataset.category = category.slug;
    };
    
    return (
        <SVGSelector {...props} image={image} svg={svg} areaSetup={setupUnitElem} sizing="fill" />
    );
});


export default UnitSelector;
